import { Injectable } from '@angular/core';
import { BaseQuery } from '../base/base.query';
import { SchemaPageStore } from './schema-page.store';

@Injectable({
  providedIn: 'root'
})
export class SchemaPageQuery extends BaseQuery {

  constructor(store: SchemaPageStore) {
    super(store);
  }


}
